import React, { useEffect, useState } from "react";
import {        postSeleccioneMedicoCirugiaDQX } from "../../../services/PaginaRuta";
import ModalDescripcionCirugiaMedico from "./ModalDescripcionCirugiaMedico";
import ModalDQRealizada from "./ModalDQRealizada";
import ModalListaDeSeleccionDeMedicosDQ from "./ModalListaDeSeleccionDeMedicosDQ";
import ModalValidarMedicoSeleccionadoRealizarDescripcionQX from "./ModalValidarMedicoSeleccionadoRealizarDescripcionQX";
import TablaSeleccioneMedicoCirugiaMEDICO from "./TablaSeleccioneMedicoCirugiaMEDICO";
import ModalValidarMedicoRealizaDescripcionQX from "./ModalValidarMedicoRealizaDescripcionQX";
//import TablaSeleccioneMedicocirugiaPROCEDIMIENTO from "./TablaSeleccioneMedicocirugiaPROCEDIMIENTO";

const ModalSeleccioneMedicoCirugia = ({ setmodalOnSeleccionMedicoCirugia, item, passChildCambioDeEstado, dataUserMedico, passDataActualizarDescripcionQX }) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
  const [modalOnDescripcionQuirurgica, setmodalOnDescripcionQuirurgica]=useState(false)
  const [modalOnAgregarMedicoDQ, setmodalOnAgregarMedicoDQ]=useState(false)
  const [datalistMedico, setdatalistMedico]=useState([])
  const [dataUser, setdataUser]=useState([])
  //const [validarMeCi, setvalidarMeCi]=useState([])
  //const [dataListProcedimiento, setdataListProcedimiento]=useState([])
  //const [dataTodosProcedimiento, setdataTodosProcedimiento]=useState([])
  //const [especialidadMedico, setespecialidadMedico]=useState([])
  const [modalOnValidarMedico, setmodalOnValidarMedico]=useState(false)
  const [modalOnValidarMedicoSeleccionadoRealizarDescripcionQX, setmodalOnValidarMedicoSeleccionadoRealizarDescripcionQX]=useState(false)
  const [loading, setloading]=useState(true)
  //const [medicoId, setmedicoId]=useState('')
  const [modalONDQRealizada, setmodalONDQRealizada]=useState(false)
  const [actualizarTablaProcedimientos, setactualizarTablaProcedimientos]=useState([])
  const [dataRealizada, setdataRealizada]=useState([])
  const [seleccionarMedico,setseleccionarMedico]=useState({
    MedCod:'',
    MMNomM:'',
    MECodE:''
  })
  
  const handleOnclickAgregarMedicoDQ=()=>{
    setmodalOnAgregarMedicoDQ(true)
  }

  const passDataMedico=(data)=>{
    setseleccionarMedico(data)
    //console.log(data,'data pass medico')
  }

  const handleCancelClick = () => {
    setmodalOnSeleccionMedicoCirugia(false);
  };

  const handleOnclickDescripcion=()=>{
    
    // validar cantidad de cirujanos que van a diligenciar la descripcion quirurgica
    // if(seleccionarMedico.MMNomM !== ''){
    //   let cantidadCirujanos= 1
    //   if(item.ProPerSe1 && item.ProPerSe2){
    //     cantidadCirujanos= 2
    //   }

    //   if(seleccionarMedico.MedCod.trim() === dataUserMedico.Codigo_medico.trim() && item.ProPerSe1.trim() === seleccionarMedico.MedCod.trim()){
    //     //console.log('1 medico')
    //     setseleccionarMedico(medico => ({
    //       ...medico,
    //       identificarMedico: 'medico uno',
    //       ProPerSe1: item.ProPerSe1,
    //       ProEspSe1: item.ProEspSe1,
    //       cantidadCirujanos
    //     }));
    //     setmodalOnDescripcionQuirurgica(true)
    //   }else if(seleccionarMedico.MedCod.trim() === dataUserMedico.Codigo_medico.trim() && item.ProPerSe2.trim() === seleccionarMedico.MedCod.trim()){
    //     setseleccionarMedico(medico => ({
    //       ...medico,
    //       identificarMedico: 'medico dos',
    //       ProPerSe1: item.ProPerSe1,
    //       ProEspSe1: item.ProEspSe1,
    //       cantidadCirujanos
    //     }));
    //     setmodalOnDescripcionQuirurgica(true)
    //   }
    //   else{
    //     setmodalOnValidarMedico(true)
    //   }
      
    // }else{
    //   setmodalOnValidarMedicoSeleccionadoRealizarDescripcionQX(true)
    // }

    //validar cirujano que va diligenciar la descripcion qx
    if(seleccionarMedico.MMNomM !== ''){
      if(seleccionarMedico.MedCod.trim() === dataUserMedico.Codigo_medico.trim()){
        let cantidadCirujanos= 1
        setseleccionarMedico(medico => ({
          ...medico,
          identificarMedico: 'medico uno',
          ProPerSe1: item.ProPerSe1,
          ProEspSe1: item.ProEspSe1,
          cantidadCirujanos
        }));
        setmodalOnDescripcionQuirurgica(true)
      }else{
        setmodalOnValidarMedico(true)
      }
    }else{
      setmodalOnValidarMedicoSeleccionadoRealizarDescripcionQX(true)
    }
    
    
   
    
  }


  useEffect(()=>{
    //console.log(item,'modla seleccione medico cirugia')
    //console.log(dataUserMedico,'informacion del medico')
    setdataUser(item)
    const body={
      vaProEmpCod:usuarioInfo.Empresa,
      varProMCDpto:usuarioInfo.Sede,
      varProCirCod: item.ProCirCod
    }
    postSeleccioneMedicoCirugiaDQX(body).then((res)=>{
      //console.log(res.data,'data nuevo')
      //setloading(false)
      setdatalistMedico(res.data)
      // setseleccionarMedico({
      //   MedCod:res.data[0].MedCod,
      //   MMNomM:res.data[0].MMNomM
      // })
      setTimeout(() => {          
        setloading(false)
      }, 2000);
    }).catch(error => {
      
      setloading(false)
    });
   
    
  },[actualizarTablaProcedimientos])
  return (
    <>
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto "
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%)] mx-auto relative w-auto pointer-events-none  bg-[#f4f6fa]">
        <div className=" overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current ">
          <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md bg-[#9e56fe]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Seleccione Médico Cirugia
            </h5>
            <button
              type="button"
              onClick={handleCancelClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          {/* { */}
            {/* // loading? <div className="text-center py-40"><Loading/></div> */}
            
            {/* //: */}
            
          <div>
          <form>
            <div className="flex-auto overflow-y-auto relative p-4">
              <div className="flex flex-row py-1  text-left">
                <div className="w-1/3  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Código
                  </label>
                  <input
                  //defaultValue={seleccionarMedico.MedCod}
                  value={seleccionarMedico.MedCod}
                    disabled={true}
                    type="text"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                </div>
                <div className="w-1/3  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Médico
                  </label>
                  <input
                     disabled={true}
                     //defaultValue={seleccionarMedico.MMNomM}
                     value={seleccionarMedico.MMNomM}
                    type="text"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                </div>
                {/* <div className="w-1/3  px-4">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Especi Cirugía
                  </label>
                  <div className="">
                    <select
                      className="form-select block  w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      aria-label="Default select example"
                    >
                      <option value="0">sin seleccionar</option>
                    </select>
                  </div>
                </div> */}
                
              </div>
              <div className="w-1/3  py-2 flex">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Se diligenció la descripción quirúrgica 
                  </label>
                  <div className="px-2">
                    <input
                      //   onChange={searchUserId}
                      //defaultValue={props.userDate[0].ProEmpCod}
                      //defaultValue={informacionUser.MPCedu}
                      //name="especialidadMedico"
                      disabled={true}
                      type="text"
                      autoComplete="off"
                      className="form-control block w-20 px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#a7f3d0] bg-clip-padding    transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                    
                  </div>
                </div>
            </div>
          </form>
          <div className="">
            <div className="flex flex-col">
              <div className="overflow-x-auto ">
                <div className="py-1 inline-block min-w-full sm:px-1 ">
                  <div className="overflow-hidden">
                    <table className="min-w-full text-center bg-gray-200">
                      <thead className="">
                        <tr>
                          <th></th>
                        <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-4 py-2"
                          >
                            
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-4 py-2"
                          >
                            Cod. Médico
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-4 py-2"
                          >
                            Nombre Médico
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-4 py-2"
                          >
                            Espec Cirugía
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-4 py-2"
                          >
                            Descripción Espec
                          </th>
                          <th
                          scope="col"
                          className="text-sm font-medium text-gray-900 px-4 py-2"
                        >
                          Proc
                        </th>
                        <th
                          scope="col"
                          className="text-sm font-medium text-gray-900 px-4 py-2"
                        >
                          Descripción Proc
                        </th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          datalistMedico.map((item,index)=>(
                            <TablaSeleccioneMedicoCirugiaMEDICO key={index} item={item} passDataMedico={passDataMedico} dataUserMedico={dataUserMedico} dataUser={dataUser}/>
                          ))
                        }
                        {/* <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr> */}
                        {/* <TablaSeleccioneMedicoCirugiaMEDICO /> */}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <h5
            className="text-xl font-medium leading-normal text-gray-800 text-center"
            id="exampleModalScrollableLabel"
          >
            PROCEDIMIENTOS
          </h5> */}
          <div className="flex flex-col">
            <div className="overflow-x-auto ">
              <div className="py-4 inline-block min-w-full sm:px-6 ">
                <div className="overflow-hidden">
                  {/* <table className="min-w-full text-center">
                    <thead className="border-b bg-gray-200">
                      <tr>
                        <th
                          scope="col"
                          className="text-sm font-medium text-gray-900 px-6 py-4"
                        >
                          Proc
                        </th>
                        <th
                          scope="col"
                          className="text-sm font-medium text-gray-900 px-6 py-4"
                        >
                          Descripción Proc
                        </th>
                        <th
                          scope="col"
                          className="text-sm font-medium text-gray-900 px-6 py-4"
                        >
                          Cod Espe
                        </th>
                        <th
                          scope="col"
                          className="text-sm font-medium text-gray-900 px-6 py-4"
                        >
                          Descripción Espe
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        dataTodosProcedimiento.map((item,index)=>(
                          <TablaSeleccioneMedicocirugiaPROCEDIMIENTO item={item} key={index} especialidadMedico={especialidadMedico}/>
                        ))
                      }
                      
                    </tbody>
                  </table> */}
                </div>
              </div>
            </div>
          </div>
          {/* <div className="w-1/3 p-3">
            <button
                type="submit"
                onClick={handleOnclickAgregarMedicoDQ}
                className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
              >
                Agregar Médico
              </button>
          </div> */}
          <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelClick}
              className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cerrar
            </button>
            <button
              type="submit"
              onClick={handleOnclickDescripcion}
              className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
            >
              Confirmar
            </button>
          </div>
          </div>
          {/* } */}
        </div>
      </div>
      {
            loading? 
            
            <div className="relative flex items-center justify-center h-screen">
            <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25" style={{ pointerEvents: "auto" }}>
                <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
                    <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
                    <p className="mt-4 text-lg">Cargando</p>
                </div>
            </div>
            <div className="absolute top-0 left-0 w-full h-full" style={{ pointerEvents: "none" }}></div>
        </div>
        :
        null
          }
    </div>
    {modalOnDescripcionQuirurgica? <ModalDescripcionCirugiaMedico setmodalOnDescripcionQuirurgica={setmodalOnDescripcionQuirurgica} item={item} dataRealizada={dataRealizada} setactualizarTablaProcedimientos={setactualizarTablaProcedimientos} passChildCambioDeEstado={passChildCambioDeEstado} seleccionarMedico={seleccionarMedico} passDataActualizarDescripcionQX={passDataActualizarDescripcionQX} handleCancelClickListaProcedimientos={handleCancelClick} datalistMedico={datalistMedico}/>:null}
    {modalOnAgregarMedicoDQ? <ModalListaDeSeleccionDeMedicosDQ setmodalOnAgregarMedicoDQ={setmodalOnAgregarMedicoDQ}/>:null}
    {modalOnValidarMedicoSeleccionadoRealizarDescripcionQX? <ModalValidarMedicoSeleccionadoRealizarDescripcionQX setmodalOnValidarMedicoSeleccionadoRealizarDescripcionQX={setmodalOnValidarMedicoSeleccionadoRealizarDescripcionQX}/>:null}
    {modalONDQRealizada? <ModalDQRealizada setmodalONDQRealizada={setmodalONDQRealizada} item={item} dataRealizada={dataRealizada}/>:null}
    {modalOnValidarMedico? <ModalValidarMedicoRealizaDescripcionQX setmodalOnValidarMedico={setmodalOnValidarMedico}/>:null}
    </>
  );
};

export default ModalSeleccioneMedicoCirugia;
